module.exports = __webpack_public_path__ + "static/media/BookEat_logo-03.a35378dd.png";